import React, { useState } from 'react';
import './PromoBadge.css';

// Строим путь «звезды-печати» (starburst seal) программно
const buildSeal = (points, cx, cy, outer, inner) => {
  let d = '';
  const step = Math.PI / points;
  for (let i = 0; i < points * 2; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const a = step * i - Math.PI / 2;
    const x = (cx + r * Math.cos(a)).toFixed(2);
    const y = (cy + r * Math.sin(a)).toFixed(2);
    d += `${i === 0 ? 'M' : 'L'}${x},${y} `;
  }
  return `${d}Z`;
};

const SEAL_PATH = buildSeal(18, 110, 110, 108, 87);

const PromoBadge = ({ variant = 'hero', skin = 'fire' }) => {
  const [closed, setClosed] = useState(false);
  if (closed) return null;

  const isFixed = variant === 'fixed';

  const handleClick = () => {
    const section = document.querySelector('.cta-section');
    if (section) {
      const rect = section.getBoundingClientRect();
      const centered = rect.top + window.pageYOffset - (window.innerHeight - rect.height) / 2;
      window.scrollTo({ top: Math.max(0, centered), behavior: 'smooth' });
    }
  };

  return (
    <div className={`promo-badge promo-badge--${variant}`}>
      {isFixed && (
        <button
          type="button"
          className="promo-badge__close"
          onClick={() => setClosed(true)}
          aria-label="Close offer"
        >
          <svg viewBox="0 0 14 14" width="12" height="12" aria-hidden="true">
            <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      )}

      <button
        type="button"
        className="promo-badge__seal-btn"
        onClick={handleClick}
        aria-label="$0 prepayment required — pay only after you pass, and get a free Module 3 demo now"
      >
        <svg className="promo-badge__seal" viewBox="0 0 220 220" aria-hidden="true">
          <defs>
            <linearGradient id="promoGold" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#FFDF9B" />
              <stop offset="48%" stopColor="#FDB241" />
              <stop offset="100%" stopColor="#E08A08" />
            </linearGradient>
          </defs>
          <path className="promo-badge__burst" d={SEAL_PATH} fill="url(#promoGold)" />
          <circle cx="110" cy="110" r="80" className="promo-badge__ring" />
        </svg>

        <span className="promo-badge__content">
          <span className="promo-badge__amount">$0</span>
          <span className="promo-badge__strong">prepayment</span>
          <span className="promo-badge__line">Pay after you pass</span>
          <span className="promo-badge__cta">FREE Module&nbsp;3 demo</span>
        </span>
      </button>

      {/* Компактный баннер — показывается вместо печати на мобильных */}
      <button
        type="button"
        className={`promo-badge__banner promo-badge__banner--${skin}`}
        onClick={handleClick}
        aria-label="$0 prepayment required — pay only after you pass, and get a free Module 3 demo now"
      >
        {skin === 'fire' && <span className="promo-badge__flame" aria-hidden="true">🔥</span>}
        {skin === 'ribbon' && <span className="promo-badge__ribbon" aria-hidden="true">Limited</span>}

        <span className="promo-badge__banner-seal">
          {(skin === 'star' || skin === 'ribbon') && (
            <svg className="promo-badge__banner-star" viewBox="0 0 220 220" aria-hidden="true">
              <defs>
                <linearGradient id="promoGoldB" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#FFE7AE" />
                  <stop offset="50%" stopColor="#FDB241" />
                  <stop offset="100%" stopColor="#E08A08" />
                </linearGradient>
              </defs>
              <path d={SEAL_PATH} fill="url(#promoGoldB)" />
            </svg>
          )}
          <span className="promo-badge__banner-amount">$0</span>
        </span>

        <span className="promo-badge__banner-text">
          <strong><span className="promo-badge__hl">No prepayment</span> — pay after you pass</strong>
          <em>+ FREE Module 3 demo</em>
        </span>
      </button>
    </div>
  );
};

export default PromoBadge;
